// Tarayıcıdan doğrudan istek CORS/500 hatasına neden olur.
// CRA setupProxy.js üzerinden /ke-api → https://app.kargoentegrator.com proxy'si kullanılır.
const BASE_URL = "/ke-api";
const API_KEY = process.env.REACT_APP_KARGOENTEK_API_KEY;

// GET isteklerinde Content-Type gönderilmez (bazı sunucular 500 fırlatır)
const getHeaders = () => ({
  Accept: "application/json",
  Authorization: `Bearer ${API_KEY}`,
});

const postHeaders = () => ({
  "Content-Type": "application/json",
  Accept: "application/json",
  Authorization: `Bearer ${API_KEY}`,
});

/**
 * Kullanıcının panelde tanımladığı kargo entegrasyonlarını listele
 * (cargo_integration_id için kullanılır)
 */
export const getCargoIntegrations = async () => {
  const res = await fetch(`${BASE_URL}/api/integration/cargos`, {
    headers: getHeaders(),
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`Kargo entegrasyonları alınamadı (${res.status}): ${body}`);
  }
  const data = await res.json();
  return data.data || data || [];
};

/**
 * Depoları listele (warehouse_id için kullanılır)
 */
export const getWarehouses = async () => {
  const res = await fetch(`${BASE_URL}/api/settings/warehouses`, {
    headers: getHeaders(),
  });
  if (!res.ok) {
    const body = await res.text().catch(() => "");
    throw new Error(`Depolar alınamadı (${res.status}): ${body}`);
  }
  const data = await res.json();
  return data.data || data || [];
};

/**
 * Yeni gönderi oluştur
 * @param {object} shipmentData
 */
export const createShipment = async (shipmentData) => {
  const res = await fetch(`${BASE_URL}/api/shipments`, {
    method: "POST",
    headers: postHeaders(),
    body: JSON.stringify(shipmentData),
  });
  if (!res.ok) {
    const errText = await res.text();
    throw new Error(`Kargo oluşturma hatası: ${errText}`);
  }
  const data = await res.json();
  return data.data || data;
};

/**
 * Gönderi detayı ve takip adımları
 * @param {number|string} shipmentId - KargoEntegratör internal ID
 */
export const getShipment = async (shipmentId) => {
  const res = await fetch(`${BASE_URL}/api/shipments/${shipmentId}`, {
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("Gönderi bilgisi alınamadı");
  const data = await res.json();
  return data.data || data;
};

/**
 * Gönderiyi iptal et / sil
 * @param {number|string} shipmentId
 */
export const cancelShipment = async (shipmentId) => {
  const res = await fetch(`${BASE_URL}/api/shipments/${shipmentId}`, {
    method: "DELETE",
    headers: getHeaders(),
  });
  if (!res.ok) throw new Error("İptal işlemi başarısız");
  return true;
};

/**
 * KargoEntegratör'de satıcı (seller) oluştur
 * @param {object} sellerData - { company, name, surname, phone, email, city, district, address, neighborhood }
 * @returns {object} - { id, ... }
 */
export const createSeller = async (sellerData) => {
  const res = await fetch(`${BASE_URL}/api/sellers`, {
    method: "POST",
    headers: postHeaders(),
    body: JSON.stringify(sellerData),
  });
  if (!res.ok) {
    const errText = await res.text();
    throw new Error(`Satıcı oluşturma hatası: ${errText}`);
  }
  const data = await res.json();
  return data.data || data;
};

/**
 * KargoEntegratör'de depo (warehouse) oluştur
 * @param {object} warehouseData - { name, person_name, person_surname, phone, email, city, district, address, postcode, seller_id }
 * @returns {object} - { id, ... }
 */
export const createWarehouse = async (warehouseData) => {
  const res = await fetch(`${BASE_URL}/api/settings/warehouses`, {
    method: "POST",
    headers: postHeaders(),
    body: JSON.stringify(warehouseData),
  });
  if (!res.ok) {
    const errText = await res.text();
    throw new Error(`Depo oluşturma hatası: ${errText}`);
  }
  const data = await res.json();
  return data.data || data;
};

/**
 * Etiket PDF'ini auth header ile çek, blob URL olarak döndür
 * @param {number|string} shipmentId
 */
export const printLabel = async (shipmentId) => {
  const res = await fetch(
    `${BASE_URL}/api/print-pdf?shipments[0]=${shipmentId}`,
    { headers: getHeaders() }
  );
  if (!res.ok) throw new Error("Etiket PDF alınamadı");
  const blob = await res.blob();
  return URL.createObjectURL(blob);
};
